export enum ResourceTypeEnum {
  mixed = 'mixed',
  files = 'files',
  links = 'links',
  empty = 'empty',
}
